const MONTH_NAMES_FR = [
  'janv', 'févr', 'mars', 'avr', 'mai', 'juin',
  'juil', 'août', 'sept', 'oct', 'nov', 'déc'
];

export function generateMonthRange(startYear: number, startMonth: number, count: number): string[] {
  const months: string[] = [];
  let y = startYear;
  let m = startMonth;

  for (let i = 0; i < count; i++) {
    const dateStr = `${y}-${String(m).padStart(2, '0')}-01`;
    months.push(dateStr);
    m++;
    if (m > 12) {
      m = 1;
      y++;
    }
  }
  return months;
}

export function formatMonthLabel(isoDate: string): string {
  const parts = isoDate.split('-');
  const monthIndex = parseInt(parts[1], 10) - 1;
  const year = parts[0].substring(2);
  return `${MONTH_NAMES_FR[monthIndex]}-${year}`;
}

export function getCurrentMonthISO(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
}

export function isCurrentMonth(isoDate: string): boolean {
  return isoDate === getCurrentMonthISO();
}
